// SAM-1065: the guest's verification code goes by SMS unless the tenant can send WhatsApp codes
// (tenant-branding `features.whatsapp_code`; missing or false = off, the picker is not drawn).
import type { CodeDeliveryMethod } from '../api/publicApi';

export const whatsappCodeEnabled = (flag?: boolean | null): boolean => flag === true;

/** The channel to send with: what the guest picked when WhatsApp is on, always SMS otherwise. */
export const effectiveCodeChannel = (picked: CodeDeliveryMethod, flag?: boolean | null): CodeDeliveryMethod =>
  whatsappCodeEnabled(flag) ? picked : 'SMS';

/** POST /sms/v2 with WHATSAPP while the tenant's flag is off: 503 {code: "WHATSAPP_UNAVAILABLE"}. */
export const isWhatsappUnavailable = (err: unknown): boolean => {
  const r = (err as { response?: { status?: number; data?: { code?: string } } } | undefined)?.response;
  return r?.status === 503 && r?.data?.code === 'WHATSAPP_UNAVAILABLE';
};
